import * as React from "react";
import { useUIFacade } from "../../../../../../../ui/facades/ui.facade";
import DateTemplate from "../../../../../../../ui/templates/columns/DateTemplate";
import NameTemplate from "../../../../../../../ui/templates/columns/NameTemplate";
import PrwcDataTableBasic from "../../../../../../../ui/widgets/custom/PrwcDataTableBasic";

const UserGroups = () => {
  const uiFacade = useUIFacade();

  const handleOnDelete = (event: any, rowData: any) => {
    uiFacade.showConfirmDeletePopup(event, rowData, deleteGroup);
  };

  const handleOnEdit = (rowData: any) => {
    console.log(rowData);
  }

  const deleteGroup = (rowData: any) => {
    console.log('delete group called ---');
    console.log(rowData);
  }

  const actionTemplate = (rowData: any) => {
    return (
      <div className="flex">
        <i className="mr-1 text-xs cursor-pointer pi pi-trash" onClick={(e: any) => handleOnDelete(e, rowData)}></i>
        <i className="text-xs cursor-pointer pi pi-pencil" onClick={(e: any) => handleOnEdit(rowData)}></i>
      </div>
    );
  };

  const data = [
    {
      id: 1,
      name: "selection_One",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 2,
      name: "selection_two",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 3,
      name: "selection_three",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 4,
      name: "selection_four",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
  ];

  const dataTable = {
    columns: [
      {
        field: "group",
        headerLabelKey: "users.label.group",
        bodyTemplate: NameTemplate,
        templateArgument: "name",
        className: "w-32 text-xs font-semibold text-blue-700",
      },
      {
        field: "validFrom",
        headerLabelKey: "users.label.validFrom",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "validTo",
        headerLabelKey: "users.label.validTo",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "action",
        bodyTemplate: actionTemplate,
        className: "w-6 text-xs",
      }
    ],
  };

  return (
    <div>
      <PrwcDataTableBasic
        data={data}
        columns={dataTable.columns}
      ></PrwcDataTableBasic>
    </div>
  );
};

export default UserGroups;
